import { MouseEventHandler, PropsWithChildren } from 'react';
import { Button } from './Button.tsx';
import { Color } from '../../lib/types.ts';
import { cn } from '../../lib/helpers.ts';

interface SmallButtonProps extends PropsWithChildren {
    color: Color | 'product';
    variant?: 'primary' | 'secondary';
    onClick?: MouseEventHandler;
    className?: string;
    disabled?: boolean;
}

export default function SmallButton({
    color,
    variant = 'secondary',
    onClick,
    disabled,
    className,
    children,
}: SmallButtonProps) {
    return (
        <Button
            color={color}
            variant={variant}
            onClick={onClick}
            disabled={disabled}
            className={cn('h-9 w-9 p-0 transition-colors', className)}
        >
            {children}
        </Button>
    );
    // return (
    //     <button
    //         className={clsx(
    //             'flex h-9 w-9 items-center justify-center rounded-xl text-product-500 transition-colors',
    //             !disabled &&
    //                 'bg-product-100 hover:bg-product-200 hover:text-product-600',
    //             !disabled ? 'cursor-pointer' : 'cursor-not-allowed',
    //             disabled && 'opacity-50'
    //         )}
    //         onClick={!disabled ? onClick : undefined}
    //     >
    //         <Icon size={12} />
    //     </button>
    // );
}
